
export default {
  methods: {
    // TODO: подключить эти функции в получение/сохранение
    /**
     *  TENDER_STATUS_CHANGED -> tenderStatusChanged
     */
    $_convertToCamelCase(str) {
      const words = str.toLowerCase().split('_')
      const camelCaseWords = words.map((word, index) => index === 0 ? word : this.$_capitalizeFirstLetter(word))
      return camelCaseWords.join('')
    },
    /**
     * Первый символ в верхний регистр
     * @param {*} str
     * @returns
     */
    $_capitalizeFirstLetter(str) {
      return str?.charAt(0)?.toUpperCase() + str?.slice(1)
    },
    /**
     * Первый символ в нихний регистр
     * @param {*} str
     * @returns
     */
    $_lowercaseFirstLetter(str) {
      return str?.charAt(0)?.toLowerCase() + str?.slice(1)
    },
    /**
     *  tenderStatusChanged -> TENDER_STATUS_CHANGED
     */
    $_convertToUpperCaseWithUnderscore(str) {
      const words = str.split(/(?=[A-Z])/) // Разделяем слова по верхнему регистру
      const upperCaseWords = words.map(word => word.toUpperCase())
      return upperCaseWords.join('_')
    },
    /**
     * Конвертируем все свойства объекта в нужный формат
     * @param {*} obj
     * @returns obj
     */
    $_formatObjectProperty(obj, mode = 'capitalizeFirstLetter') {
      if (typeof obj !== 'object' || obj === null) {
        return obj
      }

      const result = Array.isArray(obj) ? [] : {}

      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          const value = obj[key]
          let newKey = key
          switch (mode) {
          case 'upperCase':
            newKey = key.toUpperCase()
            break
          case 'capitalizeFirstLetter':
            newKey = this.$_capitalizeFirstLetter(key)
            break
          case 'lowercaseFirstLetter':
            newKey = this.$_lowercaseFirstLetter(key)
            break
          default:
            newKey = key
          }

          result[newKey] = this.$_formatObjectProperty(value, mode)
        }
      }

      return result
    },

    /**
     * Рекурсивно видаляє властивість 'Files' з об'єкта або масиву.
     * @returns {object|Array} Модифікований об'єкт.
     */
    $_removeKey(obj, keyName) {
      if (typeof obj !== 'object' || obj === null) {
        return obj
      }

      if (Array.isArray(obj)) {
        for (let i = 0; i < obj.length; i++) {
          obj[i] = this.$_removeKey(obj[i], keyName)
        }
      } else {
        const keys = Object.keys(obj)
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i]
          if (key === keyName) {
            delete obj[key]
          } else {
            obj[key] = this.$_removeKey(obj[key], keyName)
          }
        }
      }
      return obj
    },
    /**
     * Делаем HTML безопассным
     * @param {*} text
     * @returns
     */
    $_escapeHtml(text) {
      if (!text) {
        return text
      }
      var map = {
        //'&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        //'"': '&quot;',
        //'\'': '&#039;'
      }
      //return text.replace(/[&<>"']/g, function(m) { return map[m] })
      return text.replace(/[<>]/g, function(m) { return map[m] })
    },
    $_getDateCSharp(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // Добавляем 1, так как месяцы начинаются с 0
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
    },
    $_getDateFromCSharp(dateString) {
      let dateFormat = dateString ? this.$d(new Date(dateString)) : ''
      let timeFormat = dateString ? dateString.split('T')[1].split(':').slice(0, 2).join(':') : ''
      return `${dateFormat} ${timeFormat}:00`
    },
  },
}
